// Get the disallowed URLs from the robots.txt file
export const getDisallowedUrls = (robotsTxt: string): string[] =>
  (robotsTxt ?? '').split('\n').reduce((acc, line) => {
    const [key, value] = line.split(':');
    const cleanValue = value?.trim() ?? '';
    const isValid = key.startsWith('Disallow') && cleanValue.startsWith('/');

    return isValid ? [...acc, cleanValue] : acc;
  }, []);
